/* The mockup's `.pop`: a raised card that floats, the only place (with dialogs) that casts a shadow. */
.popover {
  position: fixed;
  z-index: var(--z-popover);
  inset-inline-start: var(--floating-left, 8px);
  inset-block-start: var(--floating-top, 8px);
  min-inline-size: 200px;
  max-inline-size: calc(100vw - 16px);
  padding: var(--space-1);
  border: 1px solid var(--border);
  border-radius: var(--radius-card);
  background: var(--surface-raised);
  color: var(--text);
  box-shadow: var(--shadow-popover);
  animation: pop-in var(--motion-duration) var(--motion-ease);
}

.auto {
  inline-size: auto;
}

.sm {
  inline-size: 360px;
  padding: 0;
}

.md {
  inline-size: 420px;
  padding: 0;
}

.lg {
  inline-size: 520px;
  padding: 0;
}

@keyframes pop-in {
  from {
    opacity: 0;
    transform: translateY(-4px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: none;
  }
}
